<section
  class="flex flex-wrap items-center gap-x-5 gap-y-3 rounded-2xl border border-border bg-card px-5 py-4 shadow-sm"
  aria-labelledby="phone-auth-title"
>
  <!-- Title cluster -->
  <div class="flex min-w-0 items-center gap-2.5">
    <span class="grid h-8 w-8 flex-none place-items-center rounded-lg bg-primary/10 text-primary">
      <hlm-icon name="lucideKeyRound" size="1rem" />
    </span>
    <div class="flex min-w-0 flex-col leading-tight">
      <h2
        id="phone-auth-title"
        class="font-display text-lg font-semibold text-foreground"
      >
        Employee-specific CAI TAN
      </h2>
      <span class="text-sm text-muted-foreground">
        Generate a short-lived, employee-specific TAN for CAI to continue editing a finished call.
      </span>
    </div>
  </div>

  <!-- Primary action -->
  <div class="ml-auto flex flex-none items-center">
    <button
      type="button"
      hlmBtn
      variant="default"
      size="default"
      class="gap-2"
      (click)="generateTan.emit()"
    >
      <hlm-icon name="lucideKeyRound" size="0.9rem" />
      Generate TAN
    </button>
  </div>
</section>
